import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36df2b7d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/img/kalogo.svg"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("CO")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "2", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" runter: Dashboard")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("CO")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "2", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" runter - Mein Beitrag für KA")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Dashboard")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Wie viel CO")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "2", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" kann ich durch einen veränderten Lebensstil einsparen und wie viel macht es in meinem Stadtteil aus, wenn ich noch andere in meinem Umfeld davon überzeuge? ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Die zwei Aspekte zeigt spielerisch diese App, die auf einer vereinfachten Version des CO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2"),
  /*#__PURE__*/_createTextVNode(" Rechners des Bundesumweltamtes basiert. In dieser Klima-Challenge werden nicht nur die persönlichen Ambitionen zum Klimaschutz gezeigt, sondern auch die Einsparungen, die erreicht werden können, wenn wir noch andere Menschen in unserem Umfeld für den Klimaschutz begeistern. Persönliche Maßnahmen für den Klimaschutz werden erfolgreicher, wenn wir auch andere Menschen davon überzeugen. ")
], -1))
const _hoisted_13 = { class: "mitmachen" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Machen Sie mit: ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("CO")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "2", -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" App")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Das Paris Ziel von 1,5°C ist sehr ambitioniert und bedeutet einen verbleibenden jährlichen CO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2"),
  /*#__PURE__*/_createTextVNode(" pro Kopf Ausstoß für Karlsruhe bei 2,6 Tonnen pro Person bis 2030 ("),
  /*#__PURE__*/_createElementVNode("em", null, "Paris-Diagramm"),
  /*#__PURE__*/_createTextVNode(", grüne Linie, gestrichelt). ")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Die Stadt favorisiert bisher das 1,75°C Ziel, bei dem noch 4,1 Tonnen pro Person bis 2040 verbleiben ("),
  /*#__PURE__*/_createElementVNode("em", null, "Paris-Diagramm"),
  /*#__PURE__*/_createTextVNode(", blaue Linie, gepunktet). ")
], -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode("CO")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "2", -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Bilanz")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Paris Limits")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Einsparung nach Stadtteil")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Beteiligung")
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://ok-lab-karlsruhe.de",
  target: "_blank"
}, null, -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Realisierung: ")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://ok-lab-karlsruhe.de",
  target: "_blank"
}, "OK Lab Karlsruhe", -1))
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Impressum")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_BalanceChart = _resolveComponent("BalanceChart")!
  const _component_ParisChart = _resolveComponent("ParisChart")!
  const _component_GeoChart = _resolveComponent("GeoChart")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ParticipantChart = _resolveComponent("ParticipantChart")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "topHeader" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_item, { class: "headline-container" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_thumbnail, {
                class: "logo",
                slot: "start"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_label, { class: "headline" }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _hoisted_3,
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "onepnt5"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "toprow" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card, { class: "heading1" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _hoisted_5,
                                  _hoisted_6,
                                  _hoisted_7
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_card_subtitle, null, {
                                default: _withCtx(() => [
                                  _hoisted_8
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _hoisted_9,
                              _hoisted_10,
                              _hoisted_11,
                              _hoisted_12,
                              _createElementVNode("span", _hoisted_13, [
                                _hoisted_14,
                                _createVNode(_component_ion_button, {
                                  expand: "inline",
                                  fill: "outline",
                                  href: "https://co2app.ok-lab-karlsruhe.de"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_15,
                                    _hoisted_16,
                                    _hoisted_17
                                  ]),
                                  _: 1
                                })
                              ]),
                              _hoisted_18,
                              _hoisted_19
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "12",
                    "size-md": "8"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_grid, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, { size: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_card_header, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_card_title, null, {
                                            default: _withCtx(() => [
                                              _hoisted_20,
                                              _hoisted_21,
                                              _hoisted_22
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_card_content, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_BalanceChart, {
                                            onBalanceUpdated: _cache[0] || (_cache[0] = ($event: any) => (_ctx.balanceUpdated($event)))
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                size: "12",
                                "size-md": "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_card_header, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_card_title, null, {
                                            default: _withCtx(() => [
                                              _hoisted_23
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_card_content, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ParisChart)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_col, {
                                size: "12",
                                "size-md": "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_card_header, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_card_title, null, {
                                            default: _withCtx(() => [
                                              _hoisted_24
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_card_content, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_GeoChart)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    size: "12",
                    "size-md": "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _hoisted_25
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, { class: "geochart" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ParticipantChart)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "okl",
                    size: "7"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_img, {
                        class: "okl-image",
                        src: "/img/logo.svg",
                        style: {"height":"30px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_26
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_label, { class: "okl-label" }, {
                        default: _withCtx(() => [
                          _hoisted_27,
                          _hoisted_28
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "imprint",
                    size: "5"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        expand: "block",
                        fill: "outline",
                        class: "routelink okl-button",
                        href: "https://www.karlsruhe.de/impressum"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_29
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}